import { Metric, RawDataItem } from 'utils/getTierAnalyticsSimulatorTableColumns';

interface IChartData {
    category: string;
    sales: number;
    color: string;
}
interface ILegendData {
    label: string;
    color: string;
}

export interface IChartConfig {
    chartData: IChartData[];
    legendData: ILegendData[];
    maxVal: number;
    minVal: number;
    suffix?: string;
}

export const tierAnalyticsParser = (
    rawData: RawDataItem[],
    colorMapping: { [key: string]: { chartColor: string; tableColor: string; label: string } },
) => {
    const chartData: IChartData[] = [];
    const legendData: ILegendData[] = [];

    const unitTableDataArray: RawDataItem[] = [];
    const totalTableDataArray: RawDataItem[] = [];
    let minVal = Number.MAX_VALUE;
    let maxVal = Number.MIN_VALUE;
    let chartValSuffix = '';
    let showTopBorder = false;
    rawData.forEach(({ name, data }) => {
        const totalData: Metric[] = [];
        const unitData: Metric[] = [];
        legendData.push({ label: colorMapping[name].label, color: colorMapping[name].chartColor });

        data.forEach((item) => {
            const {
                unit_type,
                metric_name,
                show_in_chart,
                kpis: { change_perc },
            } = item;
            if (show_in_chart) {
                chartData.push({
                    category: metric_name,
                    sales: change_perc.val,
                    color: colorMapping[name].chartColor,
                });
                maxVal = Math.max(maxVal, change_perc.val);
                minVal = Math.min(minVal, change_perc.val);
                if (!chartValSuffix) chartValSuffix = change_perc.post;
            }
            if (unit_type === 'total') {
                totalData.push(item);
            } else if (unit_type === 'unit') {
                if (!showTopBorder) {
                    showTopBorder = true;
                    unitData.push({ ...item, showTopBorder });
                } else unitData.push({ ...item });
            }
        });

        if (totalData.length) {
            totalTableDataArray.push({ name, data: totalData });
        }
        if (unitData.length) {
            unitTableDataArray.push({ name, data: unitData });
        }
    });
    const chartConfig: IChartConfig = { chartData, legendData, maxVal: maxVal, minVal: minVal, suffix: chartValSuffix };
    return { tableData: [...totalTableDataArray, ...unitTableDataArray], chartConfig };
};
